import React from "react";
import { BgVideo } from "../components/Homepage/BgVideo";
import Footer from "../components/Homepage/Footer";
import Header from "../components/Homepage/Header";
import { FadeIn } from "../components/Utilities/FadeIn";
import { SEO } from "../components/seo";

const IndexPage = ({ location }: { location: Location }) => {
  return (
    <div id="index-page">
      <FadeIn duration={600} delay={300}>
        <Header />
      </FadeIn>
      <FadeIn duration={600} delay={600}>
        <BgVideo />
      </FadeIn>
      <FadeIn duration={600} delay={900}>
        <Footer pathname={location.pathname} />
      </FadeIn>
    </div>
  );
};
export default IndexPage;

export function Head() {
  return (
    <>
      return <SEO title="Welcome" />;
    </>
  );
}
